// extracted by mini-css-extract-plugin
module.exports = {"asemblies-detail-wrapper":"assemblies-detail_asemblies-detail-wrapper__2O-6_"};